<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import DeleteWithConfirm from '@/components/DeleteWithConfirm';
import DepartmentFields from './components/DepartmentFields';
import service from './service';

export default {
  pageTitle: 'Детали департамента',
  async prefetchData () {
    this.isFetching = true;

    this.data = await service.getById(this.$route.params.id);

    this.name = this.data.name;
    this.color = this.data.color;
    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      isSaving: false,
      error: '',
      data: {},
      name: '',
      color: '',
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.DEPARTMENT_READ);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.DEPARTMENT_WRITE);
    },
  },
  methods: {
    handleFieldsChange (fields) {
      this.name = fields.name;
      this.color = fields.color;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving || !this.hasWritePermission) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        const { name, color } = this;

        await service.update(this.$route.params.id, { name, color });

        this.emitDataUpdate();
        this.handleClose();
      } catch (error) {
        this.isSaving = false;
        this.error = 'Ошибка при сохранении департамента';
      }
    },
    async handleDelete () {
      this.isFetching = true;
      this.error = '';

      try {
        await service.remove(this.$route.params.id);

        this.emitDataUpdate();
        this.handleClose();
      } catch (error) {
        this.isFetching = false;
        this.error = 'Ошибка при удалении департамента';
      }
    },

    handleClose () {
      this.$emit('close');
      this.$router.replace('/departments');
    },

    emitDataUpdate () {
      this.$emit('dataupdate');
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const { data, error, isFetching, isSaving, hasWritePermission } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          <span>
            Департамент
            &nbsp;
          </span>
          <span slot="sub">
            {data.name || ''}
          </span>
        </u-title>

        {isFetching ? (
          <u-spinner />
        ) : (
          <form
            action="#"
            method="post"
            onSubmit={this.handleSubmit}
          >
            <DepartmentFields
              values={data}
              disabled={isSaving}
              readonly={!hasWritePermission}
              onChange={this.handleFieldsChange}
            />

            {Boolean(error) && (
              <FormError>
                {error}
              </FormError>
            )}

            {hasWritePermission && (
              <footer class="form-footer">
                <u-btn
                  size="wide"
                  type="submit"
                >
                  {isSaving
                    ? <u-spinner inline />
                    : 'Сохранить'}
                </u-btn>

                {(data.workersCount < 1) && (
                  <span class="m-l-auto">
                    <DeleteWithConfirm onConfirm={this.handleDelete} />
                  </span>
                )}
              </footer>
            )}
          </form>
        )}
      </u-modal>
    );
  },
};
</script>
